interface OidcConfig {
  aiKey: string;
  apiUrl: string;
  oidcClientId: string;
  oidcScopeId: string;
  oidcAuthority: string;
  oidcTenantName: string;
}

declare global {
  interface Window {
    oidc: OidcConfig;
  }
}

const Config: OidcConfig = window.oidc;
export default Config;
